import { DateAgoPipe } from './date-ago.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatDataPipe } from './format-data.pipe';
import { HighlightTextPipe } from './highlight-text.pipe';
import {ReplacePipe} from "./replace.pipe";
import { NumberFormatPipe } from './number-format.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { FormatPhonePipe } from './format-phone.pipe';
import { MessagePipe } from './message.pipe';
import { SplitFileNamePipe } from './split-file-name.pipe';
import { ChildMessagePipe } from './child-message.pipe';
import { FormatBytesPipe } from './format-bytes.pipe';
import {vssProviders} from '../../vss.providers';
import {IncludesObjectPipe} from './includes-object.pipe';
import { ParseObjectPipe } from './parse-object.pipe';
import { ObjectValuePipe } from './object-value.pipe';
import { CustomPipe } from './detail-info.pipe';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IncludesObjectPipe,
    FormatDataPipe,
    HighlightTextPipe,
    ReplacePipe,
    DateAgoPipe,
    NumberFormatPipe,
    RelativeTimePipe,
    SafeHtmlPipe,
    FormatPhonePipe,
    MessagePipe,
    SplitFileNamePipe,
    ChildMessagePipe,
    FormatBytesPipe,
    ParseObjectPipe,
    ObjectValuePipe,
    CustomPipe
  ],
    exports: [
      IncludesObjectPipe,
      FormatDataPipe,
      HighlightTextPipe,
      ReplacePipe, DateAgoPipe,
      NumberFormatPipe, RelativeTimePipe,
      SafeHtmlPipe,
      FormatPhonePipe,
      MessagePipe,
      SplitFileNamePipe,
      ChildMessagePipe,
      FormatBytesPipe,
      ParseObjectPipe,
      ObjectValuePipe,
      CustomPipe
    ],
  providers: [...vssProviders]
})
export class PipeModule { }
